import * as DisplayableInCharts from './displayable-in-chart.model'
import * as GeneralTraits from './traits.shared'

// Need explicit export to create common export type T
export {
  GeneralTraits,
  DisplayableInCharts,
}

export type T = DisplayableInCharts.T // | GeneralTraits.T<name, def>
export type Name = DisplayableInCharts.Name // | GeneralTraits.T<name, def>
